import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { appRoutes } from "./api-documentation.routing";
import { ApiDocumentationComponent } from "./components/api-documentation/api-documentation.component";

@NgModule({
  declarations: [ApiDocumentationComponent],
  imports: [CommonModule, RouterModule],
  providers: [],
  bootstrap: [],
})
export class ApiDocumentationModule {}

@NgModule({
  imports: [
    CommonModule,
    ApiDocumentationModule,
    RouterModule.forChild(appRoutes),
  ],
  exports: [ApiDocumentationModule],
})
export class ApiDocumentationRoutingModule {}
